<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.821 0.0140115C15.55 0.0327098 16.8568 0.914573 17.3531 2.46827C17.7423 3.68735 17.4922 4.83273 16.6386 5.83266C13.7717 9.18965 10.9056 12.5466 8.03718 15.9023C7.51108 16.5174 6.98519 17.1327 6.44282 17.7343C5.11231 19.2111 2.86308 19.4448 1.38166 18.2703C-0.223316 16.9979 -0.469315 14.8472 0.850585 13.2735C2.45692 11.358 4.09781 9.46904 5.71725 7.56355C5.81484 7.44875 5.85505 7.28895 5.92214 7.15002C5.75385 7.09957 5.58736 7.01261 5.41704 7.005C4.83446 6.97869 4.24984 6.95629 3.66749 6.97564C1.68549 7.04109 0.0333001 5.53979 0.0116143 3.54603C-0.00984568 1.57075 1.54792 0.0568436 3.65619 0.0164031C5.3687 -0.0162102 7.0821 0.00988047 8.79506 0.00988047C10.4703 0.00988047 12.146 -0.00425195 13.821 0.0140115Z"
      fill="currentColor"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8652 16.0803C11.9059 15.5421 12.0762 15.0504 12.4271 14.6304C13.4198 13.4425 14.0365 12.7023 15.0788 11.601C15.4634 11.1947 15.7673 11.3909 15.902 11.7061C16.5125 13.1344 16.8463 14.0021 17.3823 15.4721C17.9927 17.1459 16.6362 18.9609 14.795 18.9999C14.6187 19.0036 14.4422 18.9939 14.2657 18.9904C12.7917 18.7688 11.7562 17.5155 11.8652 16.0803Z"
      fill="currentColor"
    />
  </svg>
</template>
